import { createFileRoute, redirect } from '@tanstack/react-router'
import { SEARCH_PARAM_UNIT_ID } from 'routes/(common_search_params)/-searchParams'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { Route as NewRoute } from 'routes/assets/(single_asset_destinations)/unit'
import { assetUnitPageSearchSchema } from 'routes/assets/-searchParams'

export const Route = createFileRoute(
  '/assets/(deprecated_routes)/$siteID/$unitID'
)({
  validateSearch: assetUnitPageSearchSchema,
  beforeLoad: ({ params }) => {
    const { siteID, unitID } = params
    throw redirect({
      to: NewRoute.to,
      search: (prev) => ({
        ...prev,
        [SEARCH_PARAM_SITE_ID]: siteID,
        [SEARCH_PARAM_UNIT_ID]: unitID,
      }),
      replace: true,
    })
  },
})
